import core from './core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  base(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  progress(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/progress',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  organization(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/organization',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  orglist(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/orglist',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  siljuck(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/siljuck',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  activity(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/activity',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  schedule(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/schedule',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  homeclassschedule(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/homeclassschedule',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },  
  education(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/education',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  attendCheck(parameters={}) {
    return core.call({
      url: '/api/v1/beacon/atndnCheck',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  sendProfile(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/sendProfile',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  getSsoToken(parameters={}) {
    // 1. 현재 경로 수집
    const currentUrl = window.location.pathname;
    
    // 2. URL과 코드 매핑 사전 (WAP 넘버링 적용)
    const urlMap = {
        '/main': 'WP01',                                 // 홈
        '/eduplanmap/cart': 'WP02',                      // 에듀플랜맵 장바구니
        '/mypage/myEduInfor': 'WP03',                    // 내교육정보
        '/dashboard/profile': 'WP04',                    // 명함보기
        '/showRecoEvent': 'WP05',                        // 추천 이벤트
        '/myCstmr/myCstmrView': 'WP06',                  // 고객상세
        '/myCstmr/myCstmrReg': 'WP07',                   // 고객등록
        '/orgStatus/orgStatusView': 'WP08',              // 조직현황 상세
        '/orgStatus/orgStatusView/profileDetails': 'WP09'// 조직현황 프로필 상세
    };
    
    // 3. 사전에 있는 주소면 WAP 코드를, 사전에 등록 안 된 페이지면 '99'를 보냄
    parameters.gubun = urlMap[currentUrl] || 'WP99';
    return core.call({
      url: '/api/v1/dashboard/getSsoToken',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  getMorningCheck(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/getMorningCheck',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  getUserInfo(parameters={}) {
    return core.call({
      url: '/api/v1/dashboard/getUserInfo',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'N'
      }
    });
  },
}
